// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3JVfe","productName":"Table_productName__D_mXu"};